import { Component, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { MultiSourceMultiValueWidget } from "../../base/MultiSourceMultiValueWidget";
import { MediaWidget, IMultiSourceMultiValueWidget, SharedPoint, SharedSeries } from "src/app/models/dashboard";

@Component({
  selector: 'wid-media',
  templateUrl: './media-player-widget.component.html',
  styleUrls: ['./media-player-widget.component.css']
})
export class MediaPlayerWidgetComponent extends MultiSourceMultiValueWidget implements OnChanges {
  @ViewChild('videoSource', {}) private videoSourceElement: ElementRef;
  
  public override widget: MediaWidget;
  public w: IMultiSourceMultiValueWidget;

  public carouselPosition: number = 0;
  public carouselCount: number = 3;
  public isLoaded: boolean = false;
  public isVideos: boolean = false; 
  public videos: SharedPoint[];
  public selectedVideo: SharedPoint; 

  overlays: any[];

  override ngOnInit() {
    super.ngOnInit();
  }

  override eventTypes: string[]; 
  override timeSeriesEvent(type: string, uri: string): void {
    
  }

  override widgetDataLoadComplete(): void {
      
  }

  liveDataOnly(): boolean {
    return false;//this.w.period == null || this.w.period == "";
  }

  widgetDataLoaded(s: SharedSeries) {
    if (s && s.values && s.values.length > 0) {
      this.videos = s.values.reverse();
      this.selectedVideo = this.videos[0];
      this.isVideos = true;
    }
    console.log('loaded media widget');

    this.isLoaded = true;
  };

  widgetLiveDataLoaded(s: any) {

  }


  widgetDataAdded(point: SharedPoint) {
  }

  widgetDataLoadTimeout(){
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    
  }
  
  widgetBeforeInit() {
  }

  widgetAfterInit() {
  }
  
  refresh() {
    this.loadComplete(true);
  }

  // Custom Functions
  incrementCarousel() {
    if (this.carouselPosition < this.videos.length - this.carouselCount) {
      this.carouselPosition += this.carouselCount;
    }
  }
  
  decrementCarousel() {
    if (this.carouselPosition > 0) {
      this.carouselPosition -= this.carouselCount;
    }
  }

  selectVideo(video: SharedPoint) {
    this.selectedVideo = video;
    if (this.videoSourceElement && this.videoSourceElement.nativeElement){
      this.videoSourceElement.nativeElement.load();
    }

    if (video.metaData && video.metaData['analysis'] && video.metaData['content-type'] == 'image/jpeg'){
      this.overlays = [];
      var imageMessage = video.metaData['analysis'];
      var imageOverlay = JSON.parse(imageMessage);
      const img = new Image();
      img.onload = (i:any) => {
        var img = document.getElementById('imgSource'); 
        if (img){
          var imgWidth = i.target.width;
          var imgHeight = i.target.height;
          for (let obj of imageOverlay.objects){
            const startX = (obj.rectangle.x / imgWidth) * 100;
            const startY = (obj.rectangle.y / imgHeight) * 100;
            const width = (obj.rectangle.w / imgWidth) * 100;
            const height = (obj.rectangle.h / imgHeight) * 100;
            this.overlays.push([startX,startY,width,height,obj.object]);
          }
          console.log(this.overlays);
        }
      }
      img.src = video.value;
    }
  }
}
